import { z } from "zod"

export const planespottersPhotoResponseSchema = z.union([
    z.object({
        photos: z.array(
            z.object({
                thumbnail_large: z.object({ src: z.string() }),
                link: z.string(),
                photographer: z.string(),
            })
        ),
    }),
    z.object({
        error: z.string(),
    }),
])

export type PlanespottersPhotoResponseSchema = z.infer<typeof planespottersPhotoResponseSchema>
